// Where his vending machine stands, for the close view (components/ui/VendingHud.jsx,
// components/three/world/VendingCam.jsx). Off the want Sam places in Kiwi_world.blend (ask_mve1weuy, through
// wants-sync): its root and the stand in front of it. No want, no machine. ?vendingAt=x,z stands one there for
// trying the close view before the model is in.

import { WANTS } from './wants'

export const VENDING_ASK = 'ask_mve1weuy'

export function vendingSpot() {
  if (typeof window !== 'undefined') {
    const q = new URLSearchParams(window.location.search).get('vendingAt')
    const m = q && q.split(',').map(Number)
    if (m && m.length >= 2 && m.every(Number.isFinite)) return { at: [m[0], 0, m[1]], stand: [m[0], 0, m[1] + 1.5] }
  }
  const w = WANTS[VENDING_ASK]
  if (!w?.at) return null
  return { at: w.at, stand: w.stand || [w.at[0], w.at[1], w.at[2] + 1.5] }
}

// the glass as Sam placed it (28 Oct, the model at 1.5): the window runs from 1.85 m to 3.4 m up the front, so the
// view stands back far enough to have all four rows in it, level with their middle
const BACK = 3.2
const EYE = 2.5
const AIM = 2.6

/** The close view: back from where he stands to use it, level with the glass. Heights are the want's own, which
 *  wants-sync grounds on the terrain. */
export function vendingShot(spot) {
  if (!spot) return null
  const [ax, ay, az] = spot.at
  const [sx, sy, sz] = spot.stand
  const dx = sx - ax
  const dz = sz - az
  const d = Math.hypot(dx, dz) || 1
  return { eye: [ax + (dx / d) * BACK, (sy || 0) + EYE, az + (dz / d) * BACK], target: [ax, (ay || 0) + AIM, az] }
}
